/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCustomersPageSummaryFromDiscriminatorValue, createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, type CustomersPageSummary, type ErrorResponse, type InternalErrorResponse } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/analytics/customers/summary
 */
export interface SummaryRequestBuilder extends BaseRequestBuilder<SummaryRequestBuilder> {
    /**
     * The figures in the metric row above the customer list, over active customers: how many there are and how many were added in the last 30 days; how many ordered in the last 90 days and in the same 90 days a year earlier; the reorder rate — of customers who ordered in the last 12 months, the share who ordered twice or more — and the same for the 12 months before; and the customers at risk, whose last order was 180 to 365 days ago, with their lifetime revenue and the top 50 of them by lifetime revenue. Rates are fractions between 0 and 1. Figures may be up to a few minutes old.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<CustomersPageSummary>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<CustomersPageSummary | undefined>;
    /**
     * The figures in the metric row above the customer list, over active customers: how many there are and how many were added in the last 30 days; how many ordered in the last 90 days and in the same 90 days a year earlier; the reorder rate — of customers who ordered in the last 12 months, the share who ordered twice or more — and the same for the 12 months before; and the customers at risk, whose last order was 180 to 365 days ago, with their lifetime revenue and the top 50 of them by lifetime revenue. Rates are fractions between 0 and 1. Figures may be up to a few minutes old.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const SummaryRequestBuilderUriTemplate = "{+baseurl}/api/analytics/customers/summary";
/**
 * Metadata for all the requests in the request builder.
 */
export const SummaryRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: SummaryRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createCustomersPageSummaryFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
